import React, {useEffect} from "react";
import AutoCatalog from "../../Components/AutoCatalog/AutoCatalog";
import {observer} from "mobx-react-lite";
import store from "./AutoCatalogWidgetStore";
import {PopupDataDto} from "./Dtos";

function AutoCatalogWidgetPage(props: { contextKey: string }) {
    const {contextKey} = props;
    useEffect(() => {
        function handleEvent(e: any) {
            const data = e.data as PopupDataDto;
            if (!data) return;
            
            if (data.name === "OpenPopup") {
                void store.init(contextKey, data.popupParameters.entityHrefIds);
            }
        }

        window.addEventListener('message', handleEvent);
        return function cleanup() {
            window.removeEventListener('message', handleEvent);
            store.cleanup();
        }
    }, [contextKey]);
    return <AutoCatalog store={store.store}/>
}

export default observer(AutoCatalogWidgetPage);